import React, { useEffect, useRef, useState } from "react";
import { Button, Col, Container, FormCheck, FormControl, FormLabel, Modal, Row, Spinner } from "react-bootstrap";
import css from '../css/CommonModal.module.css'
import { toast } from "react-toastify";
import messageFromError from "../../utils/errorUtils";
import ExtrasComponent from "../ExtrasComponent";
import { registerMsisdn } from "../../API/msisdnApi";
import { useTranslation } from "react-i18next";
import InfoIcon from "../InfoIcon";

const RegisterMsisdnModal = ({ companyId, extras, show, onDismiss, onRegistered }) => {

    const [isLoading, setIsLoading] = useState(false)
    const [msisdn, setMsisdn] = useState({ id: '', firstName: '', middleName: '', lastName: '', note: '', sendWelcomeSms: false });
    const msisdnExtras = useRef([])

    const { t } = useTranslation()

    useEffect(() => {
        msisdnExtras.current = extras
    }, [extras]);

    function handleMsisdnInput(e) {
        const input = e.target.value

        if (input.match(/^[0-9+][0-9]*$/g) || input.length < 1) {
            setMsisdn({ ...msisdn, id: input })
        }
    }

    function formatMsisdn(msisdn) {
        if (msisdn.startsWith('+')) {
            msisdn = msisdn.slice(1)
        }
        else if (msisdn.startsWith('0')) {
            msisdn = msisdn.slice(1)
            msisdn = '31' + msisdn
        }

        return msisdn;
    }

    async function register() {
        try {
            setIsLoading(true)
            await registerMsisdn({ ...msisdn, msisdn: formatMsisdn(msisdn.id), extras: msisdnExtras.current }, companyId)

            toast.success("Registered successfully")
            setMsisdn({ id: '', firstName: '', middleName: '', lastName: '', note: '', sendWelcomeSms: false });
            onRegistered()
            onDismiss()
        }
        catch (error) {
            toast.error(messageFromError(error))
        }
        finally {
            setIsLoading(false)
        }
    }

    return (
        <Modal show={show} onHide={onDismiss}>
            <Modal.Header closeButton className='modal-header'>
                <Modal.Title>{t('pages.workers.registerNewWorkerDialog.title')}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <FormLabel>{t('pages.workers.registerNewWorkerDialog.number')}</FormLabel>
                <FormControl type='tel' placeholder='31612345678' value={msisdn.id} onChange={handleMsisdnInput} />
                <p className={`${css.smallText} text-end`}>{t('pages.workers.registerNewWorkerDialog.msisdnLengthRequirement')}</p>
                <Container fluid>
                    <Row>
                        <Col className={'p-0 pe-2'}>
                            <FormLabel>{t('pages.workers.registerNewWorkerDialog.firstName')}</FormLabel>
                            <FormControl type='text' placeholder={t('dialogs.nameOptional')} style={{ resize: 'none' }} value={msisdn.firstName} onChange={(e) => { setMsisdn({ ...msisdn, firstName: e.target.value }) }} />
                        </Col>
                        <Col className={'p-0 ps-2'}>
                            <FormLabel>{t('pages.workers.registerNewWorkerDialog.namePrefix')}</FormLabel>
                            <FormControl type='text' placeholder={t('dialogs.nameOptional')} style={{ resize: 'none' }} value={msisdn.middleName} onChange={(e) => { setMsisdn({ ...msisdn, middleName: e.target.value }) }} />
                        </Col>
                    </Row>
                    <Row className={'mt-3'}>
                        <Col className={'p-0 pe-2'}>
                            <FormLabel>{t('pages.workers.registerNewWorkerDialog.lastName')}</FormLabel>
                            <FormControl type='text' placeholder={t('dialogs.nameOptional')} style={{ resize: 'none' }} value={msisdn.lastName} onChange={(e) => { setMsisdn({ ...msisdn, lastName: e.target.value }) }} />
                        </Col>
                    </Row>
                    {/* <Row className={'mt-3'}>
                        <Col className={'p-0'}>
                            <FormLabel>External ID</FormLabel>
                            <FormControl type='text' placeholder="Optional external ID" value={msisdn.externalId} onChange={(e) => setMsisdn({ ...msisdn, externalId: e.target.value })} />
                        </Col>
                    </Row> */}
                </Container>

                <FormLabel className='mt-3'>{t('dialogs.note')}</FormLabel>
                <FormControl as='textarea' rows={2} placeholder={t('dialogs.noteOptional')} value={msisdn.note} onChange={(e) => {
                    setMsisdn({ ...msisdn, note: e.target.value })
                }} style={{ maxHeight: "150px", marginBottom: '5px' }} />
                <ExtrasComponent extras={msisdnExtras.current} onChange={(extras) => msisdnExtras.current = extras} />
                <div className={'mt-3 d-flex align-items-center'}>
                    <FormCheck type={'checkbox'} checked={msisdn.sendWelcomeSms} onChange={(e) => {
                        setMsisdn(prev => ({ ...prev, sendWelcomeSms: e.target.checked }))
                    }} />
                    <span className={'ms-2'}>{t('pages.workers.registerNewWorkerDialog.sendWelcomeSms')}</span>
                    <InfoIcon className={'ps-1'} text={t('pages.workers.registerNewWorkerDialog.sendWelcomeSmsDescription')} size={'xs'} />
                </div>

            </Modal.Body>
            <Modal.Footer>
                {
                    isLoading ? <Spinner animation="border" variant="success" /> :
                        <Button disabled={msisdn.id.length < 8} variant="success" onClick={register}>
                            {t('pages.workers.registerNewWorkerDialog.registerBtn')}
                        </Button>
                }
            </Modal.Footer>
        </Modal>
    );
};

export default RegisterMsisdnModal;